export default "__VITE_ASSET__4edc64cc__"